import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromoContracts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2,
			width: 13,
			height: 17,
			rx: 1,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 6h2a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2",
			stroke: "#2917D6",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7,
			y1: 7,
			x2: 14,
			y2: 7,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7,
			y1: 10,
			x2: 14,
			y2: 10,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7,
			y1: 13,
			x2: 11,
			y2: 13,
			stroke: "#2917D6",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgPromoContracts;
